import WorkOrder from '../../services/workOrder'
import * as types from '../mutationTypes'

let state = {
  error: null,
  workOrders: [],
  workOrderNumbers: [],
  workOrderNumbersSearchBar: [],
  workOrder: null,
  search: null,
  headers: [
    { text: 'Work Order', value: 'workOrder.workOrderNumber' }
  ]
}

const getters = {
  workOrders (state) {
    return state.workOrders
  },
  headers () {
    return state.headers
  },
  workOrdersSelect (state) {
    return state.workOrderNumbers.map(order => {
      return { text: order.workOrderNumber, value: parseInt(order.id) }
    })
  },
  workOrderNumbers (state) {
    return state.workOrderNumbers.map(order => {
      return order.workOrderNumber
    })
  },
  workOrderNumbersSearchBar(state) {
    return state.workOrderNumbersSearchBar.map(order => {
      return order.workOrderNumber
    })
  }
}

const actions = {
  async loadWorkOrderNumbers ({ commit }, match) {
    try {
      let res = await WorkOrder.getWorkOrderNumbers(match, 250, 0)
      if (res) {
        commit(types.REQUEST_GET_WORKORDER_NUMBERS_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_WORKORDER_NUMBERS_ERROR, 'Failed to get work order numbers')
    }
  },
  async loadWorkOrderNumbersSearchBar({ commit }, match) {
    try {
      let res = await WorkOrder.getWorkOrderNumbers(match, 250, 0)
      if (res) {
        commit(types.REQUEST_GET_WORKORDER_NUMBERS_SEARCH_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_WORKORDER_NUMBERS_SEARCH_ERROR, 'Failed to get work order numbers')
    }
  },
  async createWorkOrder ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrder.create(data)
      if (res) {
        commit(types.REQUEST_CREATE_WORKORDER_SUCCESS, res.data)
      }
      return res
    } catch (err) {
      commit(types.REQUEST_CREATE_WORKORDER_ERROR, 'Error creating work order')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateWorkOrder ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await WorkOrder.update(data)
      if (res) {
        commit(types.REQUEST_UPDATE_WORKORDER_SUCCESS, res.data)
        dispatch('loadWorkOrders')
      }
    } catch (err) {
      commit(types.REQUEST_UPDATE_WORKORDER_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  }
}
const mutations = {
  [types.REQUEST_GET_WORKORDER_SUCCESS] (state, data) {
    state.workOrders = data
    state.error = null
  },
  [types.REQUEST_GET_WORKORDER_ERROR] (state, message) {
    state.error = message
    state.workOrders = []
  },
  [types.REQUEST_GET_WORKORDER_NUMBERS_SUCCESS] (state, data) {
    state.workOrderNumbers = data
    state.error = null
  },
  [types.REQUEST_GET_WORKORDER_NUMBERS_ERROR] (state, message) {
    state.error = message
    state.workOrderNumbers = []
  },
  [types.REQUEST_GET_WORKORDER_NUMBERS_SEARCH_SUCCESS](state, data) {
    state.workOrderNumbersSearchBar = data
    state.error = null
  },
  [types.REQUEST_GET_WORKORDER_NUMBERS_SEARCH_ERROR](state, message) {
    state.error = message
    state.workOrderNumbersSearchBar = []
  },
  [types.REQUEST_CREATE_WORKORDER_SUCCESS] (state) {
    state.error = null
  },
  [types.REQUEST_CREATE_WORKORDER_ERROR] (state, message) {
    state.error = message
  },
  [types.REQUEST_UPDATE_WORKORDER_SUCCESS] (state, data) {
    state.error = null
  },
  [types.REQUEST_UPLOAD_DOCUMENT_ERROR] (state, message) {
    state.error = message
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
